import React, { useState, useEffect } from 'react'

import { Grid, Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { SlotList } from '../index'

const template = {
  SITE_ID: {
    DOM: '',
    INTL: ''
  },
  PUBLISHER_ID: {
    DOM: '',
    INTL: ''
  },
  PLACEMENT_ID: {
    DOM: { DESKTOP: {}, MOBILE: {} },
    INTL: { DESKTOP: {}, MOBILE: {} }
  }
}

export const Ozone = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const OZONE = { ...template, ...VENDOR.OZONE }
  const { SITE_ID = { DOM: '', INTL: '' }, PUBLISHER_ID = { DOM: '', INTL: '' }, PLACEMENT_ID = { DOM: { DESKTOP: {}, MOBILE: {} }, INTL: { DESKTOP: {}, MOBILE: {} }} } = OZONE
  if (typeof PLACEMENT_ID?.DOM === 'string') { 
    console.log("Converting Ozone DOM Placement ID to object")
    PLACEMENT_ID.DOM = { DESKTOP: {}, MOBILE: {} } 
  }else{
    console.log('Ozone DOM Placement ID is already an object')
  }
  if (typeof PLACEMENT_ID?.INTL === 'string') { 
    console.log("Converting Ozone INTL Placement ID to object")
    PLACEMENT_ID.INTL = { DESKTOP: {}, MOBILE: {} } 
  }else{
    console.log('Ozone INTL Placement ID is already an object')
  }
  OZONE.PLACEMENT_ID = PLACEMENT_ID
  const { DOM: SITEDOM, INTL: SITEINT } = SITE_ID
  const { DOM: PUBDOM, INTL: PUBINT } = PUBLISHER_ID
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)
  VENDOR.OZONE = OZONE

  console.log("Ozone Rendering with options: ", options)

  const displayPlacementIdTable = () => {
    return (
      <Table size='small' aria-label='Ozone-display-placement-id-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6'>Placement IDs</Typography></TableCell>
            <TableCell>Domestic</TableCell>
            <TableCell>International</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Desktop</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='OZONE.PLACEMENT_ID.DOM.DESKTOP'
                object={PLACEMENT_ID?.DOM?.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Placement ID'
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='OZONE.PLACEMENT_ID.INTL.DESKTOP'
                object={PLACEMENT_ID?.INTL?.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Placement ID'
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mobile</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='OZONE.PLACEMENT_ID.DOM.MOBILE'
                object={PLACEMENT_ID?.DOM?.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Placement ID'
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='OZONE.PLACEMENT_ID.INTL.MOBILE'
                object={PLACEMENT_ID?.INTL?.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Placement ID'
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='Ozone-panel-content'
        id='Ozone-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Ozone</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table size='small' aria-label='Ozone-site-id-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '180px' }}><Typography variant='h6'>Site IDs</Typography></TableCell>
                  <TableCell>Domestic</TableCell>
                  <TableCell>International</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      margin='none'
                      value={SITEDOM}
                      error={errors.PREBID_OZONE_SIDD}
                      helperText={errors.PREBID_OZONE_SIDD && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.SITE_ID.DOM = value
                        setErrors({ ...errors, PREBID_OZONE_SIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      margin='none'
                      value={SITEINT}
                      error={errors.PREBID_OZONE_SIDI}
                      helperText={errors.PREBID_OZONE_SIDI && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.SITE_ID.INTL = value
                        setErrors({ ...errors, PREBID_OZONE_SIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <Table size='small' aria-label='Ozone-publisher-id-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '180px' }}><Typography variant='h6'>Publisher IDs</Typography></TableCell>
                  <TableCell>Domestic</TableCell>
                  <TableCell>International</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      margin='none'
                      value={PUBDOM}
                      error={errors.PREBID_OZONE_PIDD}
                      helperText={errors.PREBID_OZONE_PIDD && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.PUBLISHER_ID.DOM = value
                        setErrors({ ...errors, PREBID_OZONE_PIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      margin='none'
                      value={PUBINT}
                      error={errors.PREBID_OZONE_PIDI}
                      helperText={errors.PREBID_OZONE_PIDI && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.PUBLISHER_ID.INTL = value
                        setErrors({ ...errors, PREBID_OZONE_PIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>{displayPlacementIdTable()}</Grid>
          {/* <Grid item xs={12}>
            <Table size='small' aria-label='Ozone-placement-id-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '180px' }}><Typography variant='h6'>Placement IDs</Typography></TableCell>
                  <TableCell>Domestic</TableCell>
                  <TableCell>International</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      margin='none'
                      value={PLACEDOM}
                      error={errors.PREBID_OZONE_PLIDD}
                      helperText={errors.PREBID_OZONE_PLIDD && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.PLACEMENT_ID.DOM = value
                        setErrors({ ...errors, PREBID_OZONE_PLIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      margin='none'
                      value={PLACEINT}
                      error={errors.PREBID_OZONE_PLIDI}
                      helperText={errors.PREBID_OZONE_PLIDI && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.OZONE.PLACEMENT_ID.INTL = value
                        setErrors({ ...errors, PREBID_OZONE_PLIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid> */}
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
